const ratesSagaNamespace = 'rates-saga';
export const LOAD_RATES = `${ratesSagaNamespace}/LOAD_RATES`;
export const CREATE_RATE = `${ratesSagaNamespace}/CREATE_RATE`;
export const LOAD_QUALS = `${ratesSagaNamespace}/LOAD_QUALS`;
export const LOAD_ALL_RATES = `${ratesSagaNamespace}/LOAD_ALL_RATES`;
export const UPDATE_SP = `${ratesSagaNamespace}/UPDATE_SP`;
export const DELETE_SP = `${ratesSagaNamespace}/DELETE_SP`;
